<template>
  <div class="c-main">
    <div class="o-layout">
      <div class="o-layout__item u-1-of-2-at-medium">
        <sceSelect v-model="round.formatId" name="format" label="competitionFormat"
                   inputName="formatField" :options="formatList"
                   v-validate data-vv-rules="required"
                   v-on:change="setOptions()"
                   :class="{'is-invalid': errors.has('format')}"
                   :config="{groups: true, localized: false, emptyLabel: 'none'}" />
      </div>
      <div class="o-layout__item u-1-of-2-at-medium o-flex o-flex--align-end">
        <div class="c-input--extra-info">
          {{getFormatDescription(round.formatId)}}
        </div>
      </div>
      <div class="o-layout__item u-1-of-2-at-medium">
        <sceSelect v-model="round.tieBreakId" name="tie" label="tieBreak"
                   :config="{localized: false, emptyLabel: 'none'}"
                   inputName="tieField" :options="[{id: null, name: 'none'}, ...tieBreaks]"/>
      </div>
      <div v-if="mode === 'category'" class="o-layout__item u-1-of-2-at-medium">
        <sceNumberField name="subDivision" :class="{'is-invalid': errors.has('subDivision')}"
                        v-model.number="round.subDivisions" label="category.subDivisionsNr" min="1" max="20" step="1"
                        v-validate data-vv-rules="required|numeric|min_value:1|max_value:20"/>
      </div>
      <div class="o-layout__item u-1-of-2-at-small">
        <sceCheckBox v-model="round.requireAllEvents" name="allEvents" label="requireAllEvents" />
      </div>
    </div>
    <div v-if="hasTeamRankings()" class="o-layout">
      <div class="o-layout__item u-1-of-2-at-small">
        <sceSelect v-model="round.teamMethod" name="teamMethod"
                   :config="{ emptyLabel: 'none'}"
                   label="category.teamMethod" :options="$options.teamMethodOptions"/>
      </div>
      <div class="o-layout__item u-1-of-2-at-small">
        <sceNumberField v-if="round.teamMethod" v-model="round.teamCount" name="teamCount"
                        :label="'category.teamCount.' + round.teamMethod" min="0" max="100" step="1" />

      </div>
    </div>
    <div class="o-layout">
      <div class="o-layout__item u-1-of-2-at-medium" v-for="field of options" :key="field.config.label">
        <div v-if="showCustomField(field)" :is="'custom-field-' + field.config.inputType"
             v-model="field.value" :name="'round-' + field.config.label" :config="field.config"/>
      </div>
    </div>
    <div class="o-layout" v-if="discipline.allowTrackSelection">
      <div class="o-layout__item">
        <h4 class="c-title c-title--page-section">{{$t('categoryRound.trackSelection')}}</h4>
      </div>
      <div class="o-layout__item">
        <sceCheckBox v-model="round.trackSelection.enable" :name="'trackSelection-enable-' + round.roundIndex"
                     label="categoryRound.trackSelection.enable" />
      </div>
      <div v-if="round.trackSelection.enable" class="o-layout__item u-1-of-2-at-small">
        <categoryAwards namePrefix="selectionMinima" v-model="round.trackSelection.minima" />
      </div>
      <div v-if="round.trackSelection.enable" class="o-layout__item u-1-of-2-at-small">
        <sceSelect v-model="round.trackSelection.requirementsCheck" name="requirementsCheck"
                   label="categoryRound.trackSelection.requirementsCheck" :options="$options.trackSelection"
                   :config="{emptyLabel: 'none'}"/>
      </div>

    </div>
    <template v-if="round.roundIndex > 0">
      <h4 class="c-title c-title--page-section">{{$t('final_result')}}</h4>
      <div class="o-layout">
        <div v-for="(rt, type) of results" :key="'results-' + type"
             class="o-layout__item u-1-of-2-at-medium">
          <sceSelect v-model="rt.result" :name="'result-'+ round.roundIndex + '-'+ type" :label="'rankingType.' + type"
                     :options="$options.roundResultOptions" v-validate data-rules="required"
                     :class="{'is-invalid': errors.has('result-'+ round.roundIndex + '-'+ type)}" />
        </div>
      </div>

      <h4 class="c-title c-title--page-section">{{$t('categoryRound.selectionCriteria')}}</h4>
      <div class="o-layout">
        <div class="o-layout__item u-1-of-4-at-small">
          <sceNumberField v-model.number="round.selectionCriteria.maxCount" min="0" max="1000" step="1"
                          label="categoryRound.selectionCriteria.count" :name="'selection-count-'+ round.roundIndex"
                          v-validate data-vv-rules="required|numeric|min_value:0|max_value:1000"
                          :class="{'is-invalid': errors.has('selection-count-'+ round.roundIndex)}" />
        </div>
        <div class="o-layout__item u-1-of-4-at-small">
          <sceNumberField v-model.number="round.selectionCriteria.reserveCount" min="0" max="1000" step="1"
                          label="categoryRound.selectionCriteria.reserves" :name="'selection-reserves-'+ round.roundIndex"
                          v-validate data-vv-rules="required|numeric|min_value:0|max_value:1000"
                          :class="{'is-invalid': errors.has('selection-reserves-'+ round.roundIndex)}" />
        </div>
        <div class="o-layout__item u-1-of-4-at-small">
          <sceNumberField v-model.number="round.selectionCriteria.minScore" min="0" max="9999" step="0.001"
                          label="categoryRound.selectionCriteria.minScore" :name="'selection-min-'+ round.roundIndex"
                          v-validate data-vv-rules="required|decimal|min_value:0|max_value:9999"
                          :class="{'is-invalid': errors.has('selection-min-'+ round.roundIndex)}" />
        </div>
        <div class="o-layout__item u-1-of-4-at-small">
          <sceSelect v-model.number="round.selectionCriteria.clubCount" :name="'selection-clubCount-'+ round.roundIndex"
                     label="categoryRound.selectionCriteria.clubMax"
                     :options="[{id: 0, name: $t('unlimited')}, {id: 1, name: '1'}, {id: 2, name: '2'}, {id: 3, name: '3'}]" />
        </div>
      </div>
    </template>
    <div class="o-layout">
      <div class="o-layout__item u-1-of-2-at-small">
        <h4 class="c-title c-title--page-section">{{$t('categoryRound.singleAwards')}}</h4>

        <div class="o-layout">
          <div class="o-layout__item">
            <sceSelect v-model="round.singleAwardsType" name="singleAwardsType"
                       :options="$options.awardTypes" :config="{emptyLabel: 'none'}" />
          </div>
        </div>
        <categoryAwards v-if="round.singleAwardsType" namePrefix="singleAwards"
                        v-model="round.singleAwards" />
      </div>

      <div class="o-layout__item u-1-of-2-at-small" v-if="hasEventRankings()">
        <h4 class="c-title c-title--page-section">{{$t('categoryRound.eventAwards')}}</h4>

        <div class="o-layout">
          <div class="o-layout__item">
            <sceSelect v-model="round.eventAwardsType" name="eventAwardsType"
                       :options="$options.awardTypes" :config="{emptyLabel: 'none'}" />
          </div>
        </div>
        <categoryAwards v-if="round.eventAwardsType" namePrefix="eventAwards"
                        v-model="round.eventAwards" />
      </div>

      <div class="o-layout__item u-1-of-2-at-small" v-if="hasTeamRankings()">
        <h4 class="c-title c-title--page-section">{{$t('categoryRound.teamAwards')}}</h4>

        <div class="o-layout">
          <div class="o-layout__item">
            <sceSelect v-model="round.teamAwardsType" name="teamAwardsType"
                       :options="$options.awardTypes" :config="{emptyLabel: 'none'}" />
          </div>
        </div>
        <categoryAwards v-if="round.teamAwardsType" namePrefix="teamAwards"
                        v-model="round.teamAwards" />
      </div>
      <div class="o-layout__item u-1-of-2-at-small"
           v-if="discipline.exerciseTiming === 'category' || discipline.exerciseTiming === 'exercise'">
        <h4 class="c-title c-title--page-section">{{$t('category.exerciseTiming')}}</h4>

        <sceNumberField v-if="discipline.exerciseTiming === 'category'"
                        v-model.number="round.exerciseTime" name="exerciseTime"
                        label="session.schedule.exerciseTime" min="0" max="1200" step="1" />

        <div class="o-layout" v-if="discipline.exerciseTiming === 'exercise' && round.formatId">
          <div v-for="exercise of round.exerciseTiming" :key="exercise.type" class="o-layout__item">
            <sceNumberField v-model.number="exercise.time" :name="'exerciseTime:' + exercise.type"
                            :label="'exercise.type.'+exercise.type" min="0" max="1200" step="1" />
          </div>
        </div>
        <p v-if="discipline.exerciseTiming === 'exercise' && ! round.formatId">
          {{ $t('category.exerciseTiming.noFormat') }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
// import cloneDeep from 'lodash/cloneDeep'
import filter from "lodash/filter"
import find from "lodash/find"
import forOwn from "lodash/forOwn";
import map from "lodash/map"
import merge from "lodash/merge"
import sortBy from "lodash/sortBy"

import categoryLib from "@/lib/category"
import customFieldsLib from "@/lib/customFields"
import options from "@/lib/options";

export default {
  name: 'category-round',
  components: {
    categoryAwards: require('./awards.vue').default,
  },
  props: ['value', 'mode', 'formats', 'tieBreaks', 'discipline'],
  ...options.category,
  data: function () {
    return {
      round: {
        formatId: null,
        tieBreakId: null,
        teamMethod: 'event',
        teamCount: 3,
        exerciseTime: null,
        exerciseTiming: [],
        requireAllEvents: false,
        singleAwardsType: null,
        singleAwards: [],
        subDivisions: 1,
        teamAwardsType: null,
        teamAwards: [],
        selectionCriteria: {
          maxCount: 0,
          reserveCount: 0,
          clubCount: 0,
          minScore: 0,
        },
        trackSelection: {
          enable: false,
          minima: [],
          requirementsCheck: null,
        },
      },
      roundExerciseTypes: [],
      options: {},
      results: {
        "AA": {"result": "reset"},
        "TEAM-AA": {"result": "reset"},
        "EVENTS": {"result": "reset"},
        "TEAM-EVENTS": {"result": "reset"},
      },
    }
  },
  computed: {
    formatList: function() {
      let list = []

      const activeFormats = sortBy(filter(this.formats, f => !f.deprecated), ['index'])
      if (activeFormats.length) {
        list.push({
          name: this.$t('active'),
          elements: activeFormats,
        })
      }

      const inActiveFormats = sortBy(filter(this.formats, f => f.deprecated), ['index'])
      if (inActiveFormats.length) {
        list.push({
          name: this.$t('inactive'),
          elements: inActiveFormats,
        })
      }
      return list
    },
  },
  created: function () {
    if (this.value.results) {
      forOwn(this.value.results, (result, type) => {
        this.results[type].result = result
      })
    }
    this.round = merge(this.round, this.value)
  },
  watch: {
    round: {
      deep: true,
      handler: function () {
        this.emitValue()
      }
    },
    options: {
      deep: true,
      handler: function () {
        this.emitValue()
      }
    },
    results: {
      deep: true,
      handler: function () {
        this.emitValue()
      }
    },
    'round.formatId': {
      immediate: true,
      handler: function() {
        this.setExerciseTimes()
        this.setOptions()
        this.setRoundExerciseTypes()
      },
    },
  },
  methods: {
    setOptions: function() {
      let options = []

      let config = {}
      if (this.value.config) {
        config = this.value.config
      }
      const format = find(this.formats, i => i.id === this.round.formatId)

      if (format?.options) {
        options = options.concat(format.options)
      }
      if (this.discipline.options) {
        options = options.concat(this.discipline.options)
      }

      this.options = customFieldsLib.getFields(options, config, format)
    },
    showCustomField: function(field) {
      if (field.config.inputType === 'copy') return false

      if (! field.config.conditional) return true

      const conditionOption = this.options.find(cf => cf.config.label === field.config.conditional.option)
      return conditionOption.value === field.config.conditional.value
    },
    emitValue: function () {
      Object.assign(this.round.config, customFieldsLib.getValues(this.options))
      this.round.results = {}
      forOwn(this.results, (val, type) => {
        this.round.results[type] = val.result
      })
      this.$emit('input', this.round)
    },
    getFormatDescription: function(formatId) {
      const format = find(this.formats, item => item.id === formatId)
      return format ? format.description : this.$t('category.skipRound.description')
    },
    setExerciseTimes: function() {
      if (this.round.formatId && this.discipline.exerciseTiming === 'exercise') {
        const format = this.formats.find(f => f.id === this.round.formatId)
        const exercises = categoryLib.getExerciseTypes(format)
        const prevExerciseTiming = this.round.exerciseTiming || []
        this.round.exerciseTiming = map(exercises, exerciseTypeId => {
          const time = find(prevExerciseTiming, time => time.type === exerciseTypeId)
          return time ? time : {type: exerciseTypeId, time: undefined}
        })
      }
    },
    setRoundExerciseTypes: function() {
      let exerciseTypes = []
      if (this.round.formatId) {
        const format = find(this.formats, i => i.id === this.round.formatId)
        exerciseTypes = categoryLib.getExerciseTypes(format)
      }
      this.roundExerciseTypes = exerciseTypes.map(e => ({
        id: e,
        name: this.$t('exercise.type.' + e)
      }))
    },
    hasTeamRankings: function() {
      return this.discipline.team
    },
    hasEventRankings: function() {
      return this.discipline.events
    },
  },
}
</script>

<style scoped>
</style>
